import { Component, Input, OnInit } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { ElementVariant } from '../modules/model-viewer-urbasee/entities/element-variant.entity';
import { TextureCategory } from '../modules/openapi';
import { tap } from 'rxjs';
import { environment } from '../environments/environment';
import { CommonModule } from '@angular/common';

/**
 * Composant pour afficher l'aperçu d'un variant sur une pastille
 *
 * La pastille est composée de deux parties :
 * - La partie principale (basee), qui correspond à la couleur principale du variant (couleur rgb ou motif)
 * - La partie secondaire factultative (haute), qui correspond à la couleur secondaire du variant (couleur rgb ou motif)
 *
 */

@Component({
  imports: [CommonModule],
  selector: 'app-variant-preview',
  styles: [],
  template: `
    <div
      [style]="{
                background: primaryMotif?'url(' + primaryMotif + ')':primaryColor,
                'background-size': 'contain',
                width: '100%',
                height: '100%',
              }"
    >
      <div
        *ngIf="secondaryMotif || secondaryColor"
        [style]="{
          'clip-path':
            primaryMotif || primaryColor
              ? 'polygon(0% 0%, 100% 0%, 100% 80%, 0% 20%)'
              : '',
          background: secondaryMotif
            ? 'url(' + secondaryMotif + ')'
            : secondaryColor,
          height: '100%',
          width: '100%'
        }"
      ></div>
    </div>
  `,
  standalone: true,
})
export class VariantPreviewComponent implements OnInit {
  public test = {};
  @Input('variant') variant?: ElementVariant;
  @Input('texture-categories') textureCategories?: TextureCategory[] = [];

  public primaryColor: string = 'rgba(0, 0, 0, 0)';
  public primaryMotif?: string;
  public secondaryColor: string = 'rgba(0, 0, 0, 0)';
  public secondaryMotif?: string;

  constructor(private httpClient: HttpClient) {}
  ngOnInit(): void {
    if (!this.variant) {
      throw new Error(`[Model-Viewer-Urbasee] variant missing`);
    }
    if (!this.textureCategories) {
      throw new Error(`[Model-Viewer-Urbasee] texture-categories are missing`);
    }

    const primaryTexture = this.variant.textures[0];
    if (primaryTexture) {
      const primaryTextureColor = <any>(
        this._getTextureColorById(primaryTexture.textureColorId)
      );
      if (!primaryTextureColor) {
        throw new Error(
          `Unable to find textureColor ${primaryTexture.textureColorId}`
        );
      }
      if (primaryTextureColor.hasMotifTexture) {
        // Is a motif
        this.httpClient
          .get(
            `${environment.apiUrl}/services/v4.0/texture-color/${primaryTextureColor.id}/thumb`,
            { responseType: 'blob' }
          )
          .pipe(
            tap((blob) => {
              this.primaryMotif = URL.createObjectURL(blob);
            })
          )
          .subscribe();
      } else {
        // Is a rgb color
        this.primaryColor = `rgb(${primaryTextureColor.rgbs[0].red}, ${primaryTextureColor.rgbs[0].green}, ${primaryTextureColor.rgbs[0].blue})`;
      }
    }
    const secondaryTexture = this.variant.textures[1];
    if (secondaryTexture) {
      const secondaryTextureColor = <any>(
        this._getTextureColorById(secondaryTexture.textureColorId)
      );
      if (secondaryTextureColor) {
        if (secondaryTextureColor.hasMotifTexture) {
          // Is a motif
          this.httpClient
            .get(
              `${environment.apiUrl}/services/v4.0/texture-color/${secondaryTextureColor.id}/thumb`,
              { responseType: 'blob' }
            )
            .pipe(
              tap((blob) => {
                this.secondaryMotif = URL.createObjectURL(blob);
              })
            )
            .subscribe();
        } else {
          // Is a rgb color
          this.secondaryColor = `rgb(${secondaryTextureColor.rgbs[0].red}, ${secondaryTextureColor.rgbs[0].green}, ${secondaryTextureColor.rgbs[0].blue})`;
        }
      }
    }
  }

  _getTextureColorById(textureColorId: number) {
    let found = undefined;
    this.textureCategories?.forEach((textureCategory) => {
      textureCategory.textureColors?.forEach((textureColor) => {
        if (textureColor.id === textureColorId) {
          found = textureColor;
        }
      });
    });
    if (!found) {
      console.error(
        `[Model-Viewer-Urbasee] Texture category ${textureColorId} not found`
      );
    }

    return found;
  }
}
